import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { getDataRoomRoute } from 'utils';
import DataRoomContext from '../../providers/DataRoom/DataRoom.context';
import OnboardingContext from '../../providers/Onboarding/Onboarding.context';
import { useTranslation } from 'react-i18next';
import HelmetWrapper from 'components/HelmetWrapper';
import classNames from 'classnames';

import './RFI.styles.scss';

const RFIRouter: React.FC = () => {
  const { t } = useTranslation();

  const {
    isAdmin,
    dataRoom: { _id, name },
  } = useContext(DataRoomContext);
  const { contentCard } = useContext(OnboardingContext);

  const classes = classNames('rfi-router', 'page');

  if (!isAdmin) return <Navigate to={getDataRoomRoute(_id)} replace />;

  return (
    <div className={classes}>
      <HelmetWrapper title={`${t('fileRequests')} - ${name}`} />
      <h2>{t('fileRequests')}</h2>
      {contentCard}
      <Outlet />
    </div>
  );
};

export default RFIRouter;
